import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { OpportunityQuiz } from "../components/OpportunityQuiz";
import { Opportunities } from "../components/Opportunities";
import { HowItWorks } from "../components/HowItWorks";
import { Offer } from "../components/Offer";
import { Fleet } from "../components/Fleet";
import { About } from "../components/About";
import { Faq } from "../components/Faq";
import { FinalCta } from "../components/FinalCta";
import { ContactForm } from "../components/ContactForm";
import { Footer } from "../components/Footer";
import { CookieConsent } from "../components/CookieConsent";

export default function Landing() {
  const scrollToQuiz = () => {
    const el = document.querySelector("#quiz");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-[#0A0A0A] min-h-screen font-body">
      <Header onCtaClick={scrollToQuiz} />
      <main>
        <Hero onCtaClick={scrollToQuiz} />
        <OpportunityQuiz />
        <Opportunities />
        <HowItWorks onCtaClick={scrollToQuiz} />
        <Offer />
        <Fleet />
        <About />
        <Faq />
        <FinalCta onCtaClick={scrollToQuiz} />
        <ContactForm />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
